import React from 'react';
import PropTypes from 'prop-types';

const ProfileCircleSvg = ({ color, width, height }) => {
  return (
    <svg
      width={`${width || 16}`}
      height={`${height || 16}`}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.08014 8.52C8.03348 8.51334 7.97348 8.51334 7.92014 8.52C6.74681 8.48 5.81348 7.52 5.81348 6.34C5.81348 5.13334 6.78681 4.15334 8.00014 4.15334C9.20681 4.15334 10.1868 5.13334 10.1868 6.34C10.1801 7.52 9.25348 8.48 8.08014 8.52Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.4935 12.92C11.3068 14.0067 9.7335 14.6667 8.00017 14.6667C6.26684 14.6667 4.6935 14.0067 3.50684 12.92C3.5735 12.2933 3.9735 11.68 4.68684 11.2C6.5135 9.98666 9.50017 9.98666 11.3135 11.2C12.0268 11.68 12.4268 12.2933 12.4935 12.92Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.99967 14.6667C11.6816 14.6667 14.6663 11.6819 14.6663 8C14.6663 4.3181 11.6816 1.33333 7.99967 1.33333C4.31778 1.33333 1.33301 4.3181 1.33301 8C1.33301 11.6819 4.31778 14.6667 7.99967 14.6667Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

ProfileCircleSvg.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export default ProfileCircleSvg;
